<div class="block--content block" id="main-content">
    <ridango-page-content-wrapper>
        <rwidget-alert></rwidget-alert>

        <ridango-ui-back-button (onBack)="back()"
            >{{ 'RELATED_CARD_DETAIL_BACK_LINK' | translate }}
        </ridango-ui-back-button>

        <div class="ticket">
            <rwidget-related-card-add-and-edit-aside></rwidget-related-card-add-and-edit-aside>
            <rwidget-related-card-add-and-edit
                [(cardId)]="cardId"
                [assetsPath]="assetsPath$ | async"
                (onSaveSuccess)="handleSaveSuccess()">
            </rwidget-related-card-add-and-edit>
        </div>
    </ridango-page-content-wrapper>
</div>
